<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">メンバー一覧</v-col>
                <template v-if="plan == true && user.role == true"> <!-- 有料プランかつ管理者 -->
                    <v-col cols="12" xl="6" class="text-right">
                        <v-btn color="orange" class="white--text" @click="clickInvitation">メンバーを追加する</v-btn>
                    </v-col>
                </template>
            </v-row>
        </v-container>

        <!-- 検索エリア -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="#F4FEFB">
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#F4FEFB">
                    <form @submit.prevent="search">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="2">
                                    <badge-component tile color="unset">
                                        <label-component>メールアドレス</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-text-field v-model="searchItem.email" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <badge-component tile color="unset">
                                        <label-component>グループ</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-select
                                        v-model="searchItem.organization_id"
                                        :items="organizations"
                                        outlined
                                        clearable
                                        v-disabled-icon-focus
                                        background-color="white"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <badge-component tile color="unset">
                                        <label-component>状態</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-select
                                        v-model="searchItem.registration"
                                        :items="registrations"
                                        outlined
                                        clearable
                                        v-disabled-icon-focus
                                        background-color="white"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <label-component>
                                        <v-btn
                                            color="blue"
                                            class="white--text"
                                            type="submit"
                                        >
                                            検索
                                        </v-btn>
                                    </label-component>
                                </v-col>
                            </v-row>
                        </v-container>
                    </form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div>
            <!-- テーブル -->
            <template>
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <td class="item-td" align="center">{{ item.email }}</td>
                            <td class="item-td" align="center">{{ item.name }}</td>
                            <td class="item-td" align="center">
                                {{ item.role　== 1 ? '〇　' : '' }}
                            </td>
                            <td class="item-td" align="center">
                                {{ item.is_authorizer　== 1 ? '〇　' : '' }}
                            </td>
                            <td class="item-td">
                                <template v-for="(org, index) in item.organization_users">
                                    {{ org.organizations? org.organizations.name : '' }}
                                </template>
                            </td>
                            <td class="item-td" align="center">{{ item.work_organization ? item.work_organization.name : '' }}</td>
                            <template v-if="item.registration_status">
                                <td>
                                    <template v-if="user.role == true || user.id == item.id"> <!-- 管理者または本人 -->
                                        <v-btn color="blue" class="white--text mr-4" @click="clickDetail(item, organizations, plan, user)">詳細</v-btn>
                                    </template>
                                    <template v-if="plan == true && user.role == true && user.id != item.id"> <!-- 有料プランかつ管理者かつ本人以外 -->
                                        <v-btn color="blue-grey" class="white--text" @click="clickDelete(item)">削除</v-btn>
                                    </template>
                                </td>
                            </template>
                            <template v-else>
                                <td class="item-td" v-for="(val, index) in item.user_invitations">
                                    <!--招待に承諾している、仮パスワード更新待ち-->
                                    <template v-if="val.invitation_status">
                                        本登録待ち
                                    </template>
                                    <template v-else> 
                                        招待中
                                        <v-btn color="blue" dark class="mx-4" @click="remindInvitation(val)">リマインド</v-btn>
                                        <v-btn color="blue-grey" dark @click="deleteInvitation(val)">招待取消</v-btn>
                                        <br />（有効期限：{{ val.expiration_date  }}）
                                    </template>
                                </td>
                            </template>
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>
  
        <!-- メンバー追加 -->
        <users-invitation-dialog-component v-if="invitationDialog" :invitationDialog.sync="invitationDialog" @success="reSearch" @error="error">
            <template v-slot:ok-btn>追加</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </users-invitation-dialog-component>

        <!-- 詳細 -->
        <users-dialog-component v-if="detailDialog" :detailDialog.sync="detailDialog" 
            :item="{plan: plan, user: user, organizations: organizations, organization_users: currentItem.organization_users,
                id: currentItem.id, name: currentItem.name, email: currentItem.email, is_authorizer: currentItem.is_authorizer, role: currentItem.role == 2? 0 : 1,
                organization_id: currentItem.organization_users.organization_id,
                work_organization_id: currentItem.work_organization_id,
                work_organization: currentItem.work_organization,
            }"
            @success="reSearch" @error="error"
        >
            <template v-slot:message>詳細</template>
            <template v-slot:ok-btn>保存</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </users-dialog-component>
        
        <!-- 削除 -->
        <delete-dialog-component v-if="deleteDialog" :deleteDialog.sync="deleteDialog" :item="{id: currentItem.id, table: '/documents/delete-users/'}" @success="reSearch" @error="error">
            <template v-slot:title>{{ currentItem.name }}を削除しますか？</template>
            <template v-slot:message>削除するとメンバーの作成した送信書類の操作ができなくなります。<br />詳細はヘルプセンターをご確認ください。</template>
            <template v-slot:ok-btn>削除</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
        
        <!-- 招待リマインド -->
        <delete-dialog-component v-if="remindInvitationDialog" :deleteDialog.sync="remindInvitationDialog" :item="{id: currentItem.id, table: '/documents/remind-invitation-users/'}" @success="reSearch" @error="error">
            <template v-slot:title>リマインドしますか？</template>
            <template v-slot:message></template>
            <template v-slot:ok-btn>送信</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
        
        <!-- 招待取消 -->
        <delete-dialog-component v-if="deleteInvitationDialog" :deleteDialog.sync="deleteInvitationDialog" :item="{id: currentItem.id, table: '/documents/delete-invitation-users/'}" @success="reSearch" @error="error">
            <template v-slot:title>招待を取消しますか？</template>
            <template v-slot:message></template>
            <template v-slot:ok-btn>招待を取消する</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
    </v-container>
</template>

<script>
    export default {
        props: ['user'],
        data() {
            return {
                // 項目一覧
                items: [],
                // プラン
                plan: Boolean,
                // グループ
                organizations: [],
                registrations: [
                    {'value': 1, 'text': '本登録済み' },
                    {'value': 2, 'text': '招待中、本登録待ち' },
                ],
                // 検索項目
                searchItem: {
                    email: '',
                    organization_id: '',
                    registration: '',
                },
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                // ソート、ページネーション
                options: {},
                // テーブルヘッダー
                headers: [
                  { text: 'メールアドレス', align: 'center', value: 'email' },
                  { text: '氏名', align: 'center', value: 'name' },
                  { text: '管理者', align: 'center', sortable: false },
                  { text: '承認者', align: 'center', sortable: false },
                  { text: 'グループ', align: 'center', sortable: false },
                  { text: '作業グループ', align: 'center', sortable: false },
                  { text: '', value: 'action', sortable: false },
                  { text: '', value: 'action', sortable: false },
                ],
                // 追加フラグ
                invitationDialog: false,
                // 詳細 開閉フラグ
                detailDialog: false,
                // 削除 開閉フラグ
                deleteDialog: false,
                // 招待リマインド 開閉フラグ
                remindInvitationDialog: false,
                // 招待取消 開閉フラグ
                deleteInvitationDialog: false,
                // メッセージ
                message: null,
                success: false,
            };
        },
        methods: {
            // 追加ボタン押下
            clickInvitation(item) {
                this.invitationDialog = true;
                this.currentItem = item;
            },
            // 詳細ボタン押下
            clickDetail(item, organizations, plan, user) {
                this.detailDialog = true;
                this.currentItem = item;
                this.organizations = organizations;
                this.plan = plan;
                this.user = user;
            },
            // 削除ボタン押下
            clickDelete(item) {
                this.deleteDialog = true;
                this.currentItem = item;
            },
            // 招待リマインドボタン押下
            remindInvitation(val) {
                this.remindInvitationDialog = true;
                this.currentItem = val;
            },
            // 招待取消ボタン押下
            deleteInvitation(val) {
                this.deleteInvitationDialog = true;
                this.currentItem = val;
            },
            // 検索
            search() {
                axios.post('/documents/search', this.searchItem).then((res) => {
                    this.items = res.data.items;
                    this.plan = res.data.plan;
                    this.organizations = res.data.organizations;
                });
            },
            // 再検索
            reSearch(message) {
                axios.post('/documents/search', this.searchItem).then((res) => {
                    this.items = res.data.items;
                    this.plan = res.data.plan;
                    this.organizations = res.data.organizations;
                    this.success = true;
                    this.message = message;
                });
            },
            // エラー
            error(message) {
                this.success = false;
                this.message = message;
            }
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get-user').then((res) => {
                this.items = res.data.items;
                this.plan = res.data.plan;
                this.organizations = res.data.organizations;
            });
        },
        computed: {
            // メッセージ
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        color: black !important;
    }

    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }

    /* 検索エリア */
    .v-expansion-panels {
        margin: 10px 0;
    }
    .v-expansion-panel-content__wrap {
        padding-bottom: 0;
    }
</style>